//#region theme/frontend/islands/quantity-selector.js
var QuantitySelector = class extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input[name=\"quantity\"]");
		this.minus = this.querySelector("[data-quantity-minus]");
		this.plus = this.querySelector("[data-quantity-plus]");
		this.minus.addEventListener("click", () => {
			const v = parseInt(this.input.value, 10) || 1;
			if (v > 1) this.input.value = v - 1;
		});
		this.plus.addEventListener("click", () => {
			this.input.value = (parseInt(this.input.value, 10) || 1) + 1;
		});
	}
};
window.customElements.define("quantity-selector", QuantitySelector);
//#endregion
